import React from 'react';
import Chip from '@material-ui/core/Chip';
import { makeStyles } from '@material-ui/core/styles';
import { DOCTOR_TYPE_LABELS, DOCTOR_TYPE_COLORS } from './constants';

const useStyles = makeStyles(() => ({
  badge: {
    fontWeight: 500,
    fontSize: '0.72rem',
    height: 22,
    borderRadius: 11,
  },
}));

const DoctorTypeBadge = ({ doctorType, size = 'small', variant = 'outlined', className = '' }) => {
  const classes = useStyles();
  const label = DOCTOR_TYPE_LABELS[doctorType] || doctorType;
  const color = DOCTOR_TYPE_COLORS[doctorType] || '#757575';

  return (
    <Chip
      label={label}
      size={size}
      variant={variant}
      className={`${classes.badge} ${className}`}
      style={{ borderColor: color, color: color }}
    />
  );
};

export default DoctorTypeBadge;
